<template>
  <div class="popup calculate" ref="space" @click="handleParentClick($event, 1)">
    <div class="content" ref="content" @click="handleParentClick($event, 2)">
      <div class="content-wrapper">
        <div class="title-wrapper">
          <p :class="(mode === 'mitsumorisho') ? 'title' : 'title title-off'" @click="setMitsumorisho">{{ $t('見積書') }}</p>
          <p :class="(mode === 'seikyusho') ? 'title' : 'title title-off'" @click="setSeikyusho">{{ $t('請求書') }}</p>
        </div>

        <div class="payment-date">
          <label for="payment-date">{{ $t('お支払い期限：') }}</label>
          <input type="date" id="payment-date" ref="paymentInput" v-model="paymentDate">
        </div>

        <table ref="table">
          <tr>
            <th><p></p></th>
            <th><p>{{ $t('単価') }}</p></th>
            <th><p>{{ $t('数量') }}</p></th>
            <th><p>{{ $t('単位') }}</p></th>
            <th><p>{{ $t('価格') }}</p></th>
            <th><p></p></th>
          </tr>
          <tr v-for="(content, index) in calculateContents">
            <td><input type="text" v-model="content.name" class="td-name" @change="updateContents"></td>
            <td><input type="text" v-model="content.price" @change="updateTotalPrice(content); updateContents()" class="td-price" :readonly="content.tag === 'system_fee'"></td>
            <td><input type="text" v-model="content.quantity" @change="updateTotalPrice(content); checkName(index, content); updateContents()" class="td-quantity" :readonly="content.tag === 'system_fee'"></td>
            <td><input type="text" v-model="content.unit" class="td-unit" @change="updateContents"></td>
            <td><input type="text" v-bind:value="content.total_price" readonly class="td-price"></td>
            <td><button @click="deleteItem(index)"><img class="delete-img" src="@/assets/images/ui/trash.png" alt=""></button></td>
          </tr>
        </table>

        <div class="add-wrapper">
          <button ref="addButton" class="add-button" @click="addItem"><p>+</p></button>
        </div>

        <div class="detailed-price">
          <div class="label-wrapper">
            <label for="rough-price">{{ $t('小計') }}</label>
            <input type="text" name="rough-price" v-model="rough_price" readonly>
          </div>
          <div class="label-wrapper middle-line">
            <label for="tax">{{ $t('消費税') }}</label>
            <input type="text" name="tax" v-model="total_tax" readonly>
          </div>
          <div class="label-wrapper total-price">
            <label for="total-price">{{ $t('合計') }}</label>
            <input type="text" name="total-price" v-model="total_price" readonly>
          </div>
        </div>

        <div class="note">
          <p>{{ $t('振込先') }}</p>
          <textarea class="bank-account" name="bank-account" id="" cols="30" rows="5" :placeholder="default_bank_account.split('.').join('\n')" v-model="bank_account"></textarea>
        </div>

        <div class="note">
          <p>{{ $t('備考') }}</p>
          <textarea v-show="mode === 'mitsumorisho'" name="mitsumorisho-note" id="" cols="30" rows="5" placeholder="" v-model="note4mitsumori"></textarea>
          <textarea v-show="mode === 'seikyusho'" name="seikyusho-note" id="" cols="30" rows="5" placeholder="" v-model="note4seikyusho"></textarea>
        </div>
      </div>
      <div class="bottom-section">
        <div class="button-group">
          <a class="button border-button" @click.prevent.stop="$emit('setPrice')">
            <img src='@/assets/images/ui/gear.png' /><span>{{ $t('価格の設定') }}</span>
          </a>
          <a v-show="mode === 'mitsumorisho'" class="button green-button" @click.prevent.stop='download'>
            <img src='@/assets/images/ui/download.png' /><span>{{ $t('見積書をダウンロード') }}</span>
          </a>
          <a v-show="mode === 'seikyusho'" class="button green-button" @click.prevent.stop='download'>
            <img src='@/assets/images/ui/download.png' /><span>{{ $t('請求書をダウンロード') }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API, { graphqlOperation } from '@aws-amplify/api';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as queries from '../api/graphql/queries.ts';

import koruriFontInstaller from '../assets/fonts/Koruri-Regular-normal';
import creditPng from '../assets/images/credit.png';
import { formatPrice } from '../assets/javascripts/Formatter';
import PopupBase from "./PopupBase.vue";

export default {
  name: "CalculatePopup",
  extends: PopupBase,

  props: {
    projectId: 0,
    contractNames: {},
    facName: null,
    facAddress: null,
    facInvoice: null,
    facPostal: null,
    clientAddress: null,
    login: Boolean,
  },

  data () {
    return {
      mode: "mitsumorisho",
      manufacturing_costs: {},
      sfId: 0,
      paymentDate: new Date().toISOString().substring(0, 10),
      calculateContents: [],
      system_fee_ratio: 0,
      default_bank_account: '三井住友銀行.新宿西口(支店番号259).普通 4381259.VUILD株式会社 ヴィルドカブシキガイシャ',
      bank_account: '',
      note4mitsumori: '',
      note4seikyusho: [
        '・誠に恐れ入りますが振込手数料はご負担頂きますようお願い致します。',
        '・お振込の際、振込依頼人名義の先頭に本請求書番号を追加の上、お振込頂きますようお願い致します。（振込依頼人名義の記載例：「E501 ヴィルドタロウ」）'
      ].join('\n'),
    };
  },

  watch: {
    mode: (value) => {
      let categories = document.querySelector('.title-wrapper');
      switch (value) {
        case 'mitsumorisho':
          categories.style.setProperty('--pseudo-calc-translateX', '0px');
          break;
        case 'seikyusho':
          categories.style.setProperty('--pseudo-calc-translateX', '75px');
          break;
      }
    },

    total_price: function () {
      this.$emit('updateTotalPrice', this.total_price);
    },

    login: async function () {
      await this.setupCalcData();
    },

    clientAddress: function () {  // update when clientAddress is loaded
      this.note4mitsumori = this.note4mitsumoriContent;
    },

    contractNames: function () {  // update when contractNames is loaded
      this.note4mitsumori = this.note4mitsumoriContent;
    },

    bank_account: function () {   // update only bank account when bank account is changed (do not update clientAddress and contractNames)
      let arr = this.note4mitsumori.split('\n');
      let index = arr.indexOf('振込先');
      arr[index+1] = this.bank_account;
      this.note4mitsumori = arr.join('\n');
    }
  },

  computed: {
    rough_price: function () {
      let price_array = this.calculateContents.map((content) => {return Math.floor(content.total_price)});
      return price_array.reduce((acc, cur) => acc+ cur, 0);
    },

    total_tax: function () {
      return Math.floor(this.rough_price * 0.1);
    },

    total_price: function () {
      return this.rough_price + this.total_tax;
    },

    note4mitsumoriContent: function () {
      return `納品先：〒${this.clientAddress.postal} ${this.clientAddress.address} ${this.clientAddress.name} ${(this.contractNames.corporateName) ? `御中` : `様`}` + '\n' +
      `支払い期日：${this.paymentDate.split('-').join('/')}` + '\n' + '\n' +
      '※設計データから±1mm程度の加工誤差が生じることがあります。' + '\n' +
      '※合板のポケット加工の場合、積層の位置によって設計より1-2mm深くなる場合があります。' + '\n' +
      '※湿気による木材の膨れ、反りが生じる可能性があります。' + '\n' +
      '※乾燥による収縮、反りが起きることがあります。' + '\n' +
      '※木材には個体差があり、データのレイアウトや形状によって節、われ、ヒビが表面に出る可能性があります。' + '\n' +
      '※同じ材種でも、加工拠点によって色味・節などの個体差がある場合があります。' + '\n' +
      '※配送中の扱い方によっては、表面に傷がつく可能性があります。' + '\n' + '\n' +
      '振込先' + '\n' +
      this.bank_account.split('\n').join(' ') + '\n' +
      '※誠に恐れ入りますが振込手数料はご負担をお願い致します。' + '\n' +
      '※お振込の際、個人のお客様は振込依頼人名義の先頭に、本見積書番号「E〇〇（もしくはM〇〇）」を追加の上、お振込頂きますようお願い致します。 （振込依頼人名義の記載例：「E501 ヴィルドタロウ」）'
    },
  },

  async mounted() {
    if (this.login) {
      await this.setupCalcData();
    }

    // bind data instead of computed value so that it becomes editable
    this.note4mitsumori = this.note4mitsumoriContent;
  },

  methods: {
    handleParentClick(event, num) {
      // writing 'click.prevent.stop' directly in the parent div will cause no-function checkbox.
      if (event.target.type !== 'date') {
        event.preventDefault();
        event.stopPropagation();
        if (num === 1) {
          this.$emit('closeCalculatePopup');
        }
      }
    },

    async setupCalcData () {
      const myID = await this.getCurrentUserId();

      const sbp = this.$route.query.sbp;
      const toolPathUrl = decodeURIComponent(sbp);
      const getProjectIdresult = await this.getProjectId(toolPathUrl);
      const projectFactory = await this.getProjectFactory(getProjectIdresult.id);

      const items = JSON.parse(
        projectFactory.items
          .replace(/^{/, '{"')
          .replace(/=/g, '":"')
          .replace(/, /g, '", "')
          .replace(/}$/, '"}')
      )

      this.manufacturing_costs = await this.getCostSetting(myID);

      const materialAssortment = await this.getMaterialAssortment(
        myID,
        projectFactory.material_assortment.material_id,
        projectFactory.material_assortment.thickness,
        projectFactory.material_assortment.height,
        projectFactory.material_assortment.width
      );

      const materialCostPerSheet = materialAssortment.unit_price;
      const materialDescription = [
        `${projectFactory.material_assortment.material.name}`,
        `${projectFactory.material_assortment.thickness}mm`,
        `${items.num_sheets_cost}枚`
      ].join(' ');

      const finishingCostPerMin = this.getFinishingCostPerMin(items);

      // Calculate individual costs
      const manufacturingCost = Math.floor(this.manufacturing_costs.cutting_cost * this.secondToHour(items.cutting_totaltime));
      const materialCost = Math.floor(materialCostPerSheet * Number(items.num_sheets_cost));
      const finishingCost = Math.floor(this.getFinishingTotalPrice(items, finishingCostPerMin));
      const chamferingCost = Math.floor(this.manufacturing_costs.edge_chamfering_cost);
      
      // Store system fee ratio for dynamic updates
      this.system_fee_ratio = items.system_fee_ratio;
      
      // Calculate system fee based on total of above costs
      const systemFee = Math.floor((manufacturingCost + materialCost + finishingCost + chamferingCost) * items.system_fee_ratio);

      this.calculateContents = [
        {
          tag: "manufacturing_cost",
          name: `${this.$t('加工費')}（${this.formatHour(this.secondToHour(items.cutting_totaltime))}）`,
          price: this.manufacturing_costs.cutting_cost,
          quantity: this.secondToHour(items.cutting_totaltime),
          unit: this.$t('時間').trim(),
          total_price: manufacturingCost
        },
        {
          tag: "material_cost",
          name: `材料費（${materialDescription}）`,
          price: materialCostPerSheet,
          quantity: items.num_sheets_cost,
          unit: "枚",
          total_price: materialCost
        },
        {
          tag: "finishing_cost",
          name: this.getFinishingDescription(items),
          price: finishingCostPerMin,
          quantity: this.getFinishingQuantity(items),
          unit: this.$t('分').trim(),
          total_price: finishingCost
        },
        {
          tag: "chamfering_cost",
          name: (this.manufacturing_costs.edge_chamfering_cost) ? "面取り（糸面取り）" : "面取り（ - ）",
          price: this.manufacturing_costs.edge_chamfering_cost,
          quantity: 1,
          unit: "式",
          total_price: chamferingCost
        },
        {
          tag: "system_fee",
          name: "システム利用料",
          price: systemFee,
          quantity: 1,
          unit: "式",
          total_price: systemFee
        },
        {
          tag: "shipping_cost",
          name: "配送費",
          price: 0,
          quantity: 1,
          unit: "式",
          total_price: 0
        },
        {
          tag: "packaging_cost",
          name: "梱包費",
          price: 0,
          quantity: 1,
          unit: "式",
          total_price: 0
        },
      ];

      this.$emit('updateCalculateContents', this.calculateContents, this.total_tax);
    },

    secondToMin (seconds) {
      return Math.ceil(Number(seconds) / 60);
    },

    secondToHour (seconds) {
      let minutes = this.secondToMin(seconds);
      return Number((minutes / 60).toFixed(4));
    },

    formatHour (hourNum) {
      let hour = Math.floor(hourNum);
      let min = Math.floor((hourNum - hour) * 60);
      return `${hour}${this.$t('時間')}${min}${this.$t('分')}`;
    },

    getFinishingCostPerMin (items) {
      const { cost_burr, cost_sanding } = items;

      if (cost_burr !== "0" && cost_sanding === "0") {
        return this.manufacturing_costs.burr_cost;
      } else if (cost_burr !== "0" && cost_sanding !== "0") {
        return this.manufacturing_costs.burr_sanding_cost;
      }
      return 0;
    },

    getFinishingDescription (items) {
      const { cost_burr, cost_sanding } = items;

      if (cost_burr === "0" && cost_sanding === "0") {
        return "仕上げ費（ - ）";
      } else if (cost_burr !== "0" && cost_sanding === "0") {
        return "仕上げ費（バリ取り）";
      } else if (cost_burr !== "0" && cost_sanding !== "0") {
        return "仕上げ費（バリ取り+表面研磨）";
      }
      return "仕上げ費";
    },

    getFinishingQuantity (items) {
      if (items.cost_burr === "0" && items.cost_sanding === "0") {
        return 0
      }
      return this.secondToMin(items.cutting_totaltime)
    },

    getFinishingTotalPrice (items, cost) {
      if (items.cost_burr === "0" && items.cost_sanding === "0") {
        return 0
      }
      const minutes = this.secondToMin(items.cutting_totaltime);
      return cost * minutes;
    },

    async getCurrentUserId () {
      const { data } = await API.graphql(graphqlOperation(queries.getCurrentUserId, {}));
      return data.getCurrentUserId;
    },

    async getProjectId (toolPathUrl) {
      // CAUTION: cognito user pool認証(デフォルト)だと非ログインユーザではgraphqlが権限エラーになる
      const { data } = await API.graphql({
        query: queries.getProjectId,
        variables: {
          toolpath_url: toolPathUrl
        },
        authMode: 'API_KEY'
      });
      return data[`getProjectId`];
    },

    async getProjectFactory (projectId) {
      const { data } = await API.graphql(graphqlOperation(queries.getProjectFactory, { id: projectId }));
      return data.getProjectFactory;
    },

    async getCostSetting (userId) {
      const { data } = await API.graphql(graphqlOperation(queries.getCostSetting, { user_id: userId }));
      return data.getCostSetting || {};
    },

    async getMaterialAssortment (userId, materialId, thickness, height, width) {
      const { data } = await API.graphql(graphqlOperation(queries.getMaterialAssortment, {
        input: {
          user_id: userId,
          material_id: materialId,
          thickness: thickness,
          height: height,
          width: width
        }
      }));
      return data.getMaterialAssortment || {};
    },

    checkName (index, content) {
      if (index === 0) { // when setting 加工時間
        content.name = `加工費（${this.formatHour(content.quantity)}）`;
      } else if (index === 1) {
        content.name = `${ content.name.substring(0, content.name.lastIndexOf(' ')) } ${content.quantity}枚）`;
      } else {
        return;
      }
    },
    setMitsumorisho () {
      this.mode = 'mitsumorisho';
    },
    setSeikyusho () {
      this.mode = 'seikyusho';
    },
    updateTotalPrice (content) {
      content.total_price = Math.floor(content.price * content.quantity);
      
      // Update system fee when related costs change
      this.updateSystemFee();
    },
    updateSystemFee () {
      // Find the system fee item in calculateContents
      const systemFeeItem = this.calculateContents.find(item => item.tag === 'system_fee');
      if (!systemFeeItem || this.system_fee_ratio === 0) return;
      
      // Calculate total of related costs
      const manufacturingCostItem = this.calculateContents.find(item => item.tag === 'manufacturing_cost');
      const materialCostItem = this.calculateContents.find(item => item.tag === 'material_cost');
      const finishingCostItem = this.calculateContents.find(item => item.tag === 'finishing_cost');
      const chamferingCostItem = this.calculateContents.find(item => item.tag === 'chamfering_cost');
      
      const manufacturingCost = manufacturingCostItem ? manufacturingCostItem.total_price : 0;
      const materialCost = materialCostItem ? materialCostItem.total_price : 0;
      const finishingCost = finishingCostItem ? finishingCostItem.total_price : 0;
      const chamferingCost = chamferingCostItem ? chamferingCostItem.total_price : 0;
      
      // Update system fee
      const newSystemFee = Math.floor((manufacturingCost + materialCost + finishingCost + chamferingCost) * this.system_fee_ratio);
      systemFeeItem.price = newSystemFee;
      systemFeeItem.total_price = newSystemFee;
    },
    updatePrice () {
      this.$emit('updateTotalPrice', this.total_price);
    },
    updateContents () {
      // console.log(this.calculateContents);
      // emit this.calculateContents
      // use emitted calculateContents to construct the details in leftMenu

      // memo: NEED to make first emit in the mounted()
      this.$emit('updateCalculateContents', this.calculateContents, this.total_tax);
    },
    addItem () {
      this.calculateContents.push(
        {
          tag: 'newly-added item',
          name: "入力してください",
          price: 0,
          quantity: 1,
          unit: "式",
          total_price: 0
        });
    },
    deleteItem (index) {
      if (confirm('項目を削除します。よろしいですか？')) {
        this.calculateContents.splice(index, 1);
      }
    },
    create () {
      const doc = new jsPDF();

      koruriFontInstaller(doc);
      doc.setFont('Koruri-Regular', 'normal');

      // doc.text("Hello world!", 10, 10);
      doc.setFillColor(248, 248, 248);
      doc.rect(0, 0, 210, 297, 'F');

      const width = 210;

      doc.setFontSize(22);
      doc.text((this.mode === 'mitsumorisho') ? '見積書' : (this.mode === 'seikyusho') ? '請求書' : '', 105, 20, null, null, 'center');
      let y1 = this.addTextLines({
        doc: doc,
        lines: [
          (this.contractNames.corporateName) ? `${this.contractNames.corporateName} 御中` : (this.contractNames.personalName) ? `${this.contractNames.personalName} 様` : '未設定',
        ],
        textWidth: 60,
        xPosition: 10,
        initialYPosition: 40,
        fontSize: fontSize
      });

      // doc.addImage(hankoPng, 'png', 170, 35, 30, 30);
      let fontSize = 13;
      let small_fontSize = 10;

      let today = new Date();
      let expired = new Date(today.getFullYear(), today.getMonth()+2, 0); // the end of next month
      // let expired = new Date();
      // expired.setDate(today.getDate() + 30);

      let invoice = (this.mode === 'seikyusho') ? [`登録番号：${(this.facInvoice) ? this.facInvoice : '未設定'}`, ''] : [''];

      let y2 = this.addTextLines({
        doc: doc,
        lines: [
          (this.facName) ? this.facName : '未設定',
          ...invoice,
          (this.facPostal) ? `〒${this.facPostal}` : '未設定',
          (this.facAddress) ? this.facAddress : '未設定',
          '',
          `${(this.mode === 'seikyusho') ? '請求書番号' : '見積書番号'}：E${this.projectId}`,
          `発行日：${this.dateFormat(today)}`,
          (this.mode === 'seikyusho') ? `お支払い期限：${this.paymentDate.split('-').join('/')}` : `有効期限：${this.dateFormat(expired)}`
        ],
        textWidth: 80,
        xPosition: 140,
        initialYPosition: 40,
        fontSize: small_fontSize,
        textAlign: 'left'
      });

      let cursorY = Math.max(y1, y2) - 22;

      doc.setFontSize(fontSize);
      doc.text(`件名：EMARF加工費`, 10, cursorY, null, null, 'left');

      cursorY += 12;

      let letters = `${(this.mode === 'seikyusho') ? 'ご請求金額' : 'お見積金額'} ${formatPrice(this.total_price)}円`;
      let text_width = (doc.getStringUnitWidth(letters) / (72/25.6)) * fontSize;  // divide by (72/25.6) to turn "points" into "mm"
      let line_width = 1;
      let padding = 2;
      let bg_width = text_width + line_width + (2*padding);
      doc.setFillColor(235, 235, 235);
      doc.rect(10, cursorY - 8.5, bg_width, fontSize, 'F'); // text background

      doc.setFillColor(0, 0, 0);
      doc.rect(10, cursorY - 8.5, line_width, fontSize, 'F'); // black line

      doc.text(letters, 10 + line_width + padding, cursorY, null, null, 'left');

      // let subTotal = this.cost.total_cost;
      // let tax = this.cost.total_cost_tax - subTotal;
      // let total = subTotal + tax;

      cursorY += 10;

      // doc.text(`御見積金額 ${formatPrice(total)}`, 10, cursorY);
      // cursorY += 7;

      doc.autoTable({
        startY: cursorY,
        margin: {
          top: 0,
          left: 10,
          right: 10,
          bottom: 0
        },
        styles: {
          font: 'Koruri-Regular',
          fontSize: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0]
        },
        headStyles: {
          font: 'Koruri-Regular',
          fontStyle: 'normal',
          fillColor: [235, 235, 235],
          cellPadding: [3, 0, 3, 2],
        },
        alternateRowStyles: {
          fillColor: [248, 248, 248]
        },
        head: [[
          '品目',
          '単価',
          '数量',
          '単位',
          '価格'
        ]],
        body: this.calculateContents.map(obj => Object.values(obj).slice(1)), // slice 'tag'
      });

      cursorY = doc.autoTable.previous.finalY + 10;

      doc.text(`小計`, 140, cursorY, null, null, 'left');
      doc.text(`${formatPrice(this.rough_price)}`, 200, cursorY, null, null, 'right');
      // let title_width = (doc.getStringUnitWidth(`小計`) / (72/25.6)) * fontSize;
      // let number_width = (doc.getStringUnitWidth(`${formatPrice(this.rough_price)}`) / (72/25.6)) * fontSize;
      doc.setDrawColor(0, 0, 0);
      doc.line(140, cursorY + 2, 200, cursorY + 2, 'F')

      cursorY += 9;
      doc.text(`消費税`, 140, cursorY, null, null, 'left');
      doc.text(`${formatPrice(this.total_tax)}`, 200, cursorY, null, null, 'right');
      doc.setDrawColor(0, 0, 0);
      doc.line(140, cursorY + 2, 200, cursorY + 2, 'F')

      cursorY += 9;
      doc.text(`合計`, 140, cursorY, null, null, 'left');
      doc.text(`${formatPrice(this.total_price)}`, 200, cursorY, null, null, 'right');
      doc.setDrawColor(0, 0, 0);
      doc.line(140, cursorY + 2, 200, cursorY + 2, 'F')

      switch (this.mode) {
        case 'mitsumorisho':
          cursorY += 9;
          doc.text(`内訳`, 140, cursorY, null, null, 'left');
          doc.setFontSize(small_fontSize);
          doc.text(`10%対象`, 175, cursorY, null, null, 'right');
          doc.text(`${formatPrice(this.rough_price)}`, 200, cursorY, null, null, 'right');

          cursorY += 9;
          doc.text(`消費税`, 175, cursorY, null, null, 'right');
          doc.text(`${formatPrice(this.total_tax)}`, 200, cursorY, null, null, 'right');
          doc.setFontSize(fontSize);
          break;
        case 'seikyusho':
          cursorY -= 18;
          doc.setFontSize(small_fontSize);
          doc.text(`税率別内訳`, 10, cursorY, null, null, 'left');

          cursorY += 9;
          doc.text(`税抜金額`, 60, cursorY, null, null, 'right');
          doc.text(`消費税額`, 90, cursorY, null, null, 'right');
          doc.text(`税込金額`, 120, cursorY, null, null, 'right');
          doc.setDrawColor(0, 0, 0);
          doc.line(10, cursorY + 2, 120, cursorY + 2, 'F')
          doc.line(30, cursorY - 4, 30, cursorY + 11, 'F')

          cursorY += 9;
          doc.text(`10%対象`, 10, cursorY, null, null, 'left');
          doc.text(`${formatPrice(this.rough_price)}`, 60, cursorY, null, null, 'right');
          doc.text(`${formatPrice(this.total_tax)}`, 90, cursorY, null, null, 'right');
          doc.text(`${formatPrice(this.total_price)}`, 120, cursorY, null, null, 'right');
          doc.setDrawColor(0, 0, 0);
          doc.line(10, cursorY + 2, 120, cursorY + 2, 'F')
          doc.setFontSize(fontSize);

          cursorY += 10;
          let bank_lineHeight = 7;
          // let testBank = ['三井住友銀行', '新宿西口(支店番号259)', '普通 4381259', 'VUILD株式会社 ヴィルドカブシキガイシャ']
          let bank_arr = this.bank_account.split('\n');
          let info_height = (bank_lineHeight * bank_arr.length) + (bank_lineHeight - fontSize/(72/25.6)); // (lineHeight * rows) + (space for bottom)
          doc.setFillColor(235, 235, 235);
          doc.rect(10, cursorY, 190, info_height, 'F'); // text background
          doc.setFillColor(0, 0, 0);
          doc.rect(10, cursorY, line_width, info_height, 'F'); // black line

          cursorY += bank_lineHeight;
          doc.text(`振込先`, 10 + 5, cursorY, null, null, 'left');
          for (let content of bank_arr) {
            doc.text(content, 40, cursorY, null, null, 'left');
            cursorY += bank_lineHeight;
          }

          cursorY += 5;
          break;
      }

      // cursorY += 10;

      doc.setFontSize(14);
      doc.text('備考', 10, cursorY);

      cursorY += 9;


      let noteContent = (this.mode === 'mitsumorisho') ? this.note4mitsumori : (this.mode === 'seikyusho') ? this.note4seikyusho : '';
      let noteArr = noteContent.split("\n");
      let note_lineHeight = 4;
      console.log(noteArr.length);
      let note_height = (note_lineHeight * (noteArr.length + 2)) + (note_lineHeight - small_fontSize/(72/25.6)); // (lineHeight * rows) + (space for bottom)

      doc.setDrawColor(235, 235, 235);
      doc.setLineWidth(0.5);
      // doc.rect(10, cursorY - 5, 190, (this.mode === 'mitsumorisho') ? 40 : (this.mode === 'seikyusho') ? 20 : 10, 'S');
      doc.rect(10, cursorY - 5, 190, note_height, 'S');

      this.addTextLines({
        doc: doc,
        lines: noteArr.map(text => `${text}`),
        textWidth: 187,
        xPosition: 10 + 2,
        initialYPosition: cursorY,
        fontSize: small_fontSize,
        lineSpacing: note_lineHeight
      });

      cursorY += 20;

      doc.addImage(creditPng, 'png', 10, 297 - 12 - 10, 15.5, 12);

      return doc;
    },
    addTextLines ({doc, lines, textWidth = 80, textAlign = 'left', fontSize = 14, lineSpacing = 7, xPosition = 10, initialYPosition = 10}) {
      let cursorY = initialYPosition;
      lines.forEach(line => {
        cursorY = this.addWrappedText({
          doc: doc,
          text: line,
          textWidth: textWidth,
          textAlign: textAlign,
          fontSize: fontSize,
          lineSpacing: lineSpacing,
          xPosition: xPosition,
          initialYPosition: cursorY
        });
      });
      return cursorY;
    },
    addWrappedText ({doc, text, textWidth, textAlign = 'left', fontSize = 10, lineSpacing = 7, xPosition = 10, initialYPosition = 10, pageWrapInitialYPosition = 10}) {
      doc.setFontSize(fontSize);

      let textLines = doc.splitTextToSize(text, textWidth); // Split the text into lines
      let pageHeight = doc.internal.pageSize.height; // Get page height, we'll use this for auto-paging. TRANSLATE this line if using units other than `pt`
      let cursorY = initialYPosition;

      textLines.forEach(lineText => {
        if (cursorY > pageHeight) { // Auto-paging
          doc.addPage();
          cursorY = pageWrapInitialYPosition;
        }
        doc.text(lineText, xPosition, cursorY, null, null, textAlign);
        cursorY += lineSpacing;
      });

      return cursorY;
    },
    dateFormat (date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return `${year}/${month}/${day}`;
    },
    async download () {
      console.log('pdf test');

      if (this.bank_account.length != 0) {
        if (this.mode === 'seikyusho') {
          this.$emit('updateSF', this.calculateContents);
        }
        let doc = this.create();
        doc.output('dataurlnewwindow'); // view pdf file in browser window without download
        // doc.save(`見積もり.pdf`);

      } else {
        alert('振込先を入力してください');
      }
    }
  },
};
</script>

<style lang="scss" >
:root {
  --pseudo-calc-translateX: 0px;
}
.calculate {
  .content {
    width: 800px;
    // height: fit-content;
    max-height: 700px;
    height: 700px;
    // overflow-y: scroll;
    overflow: hidden;
    border-radius: 20px;
    font-size: 12px;
    font-weight: bold;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;

    background-color: rgba($color: #ffffff, $alpha: 1.0);
    padding: 2rem 20px;
    position: relative;

    .content-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: end;
      // justify-content: end;
      height: calc(700px - 2rem - 80px);
      overflow-y: scroll;
      padding: 0 2rem;

      .title-wrapper {
        width: 100%;
        display: flex;
        position: relative;
        margin-top: .5rem;
        .title {
          font-size: 20px;
          margin-bottom: 2rem;
          margin-right: 1rem;
          cursor: pointer;
        }

        .title-off {
          opacity: .5;
        }

        &::before {
          content: '';
          position: absolute;
          width: 60px;
          height: 5px;
          background-color: #1bffc6;
          border-radius: 99em;
          bottom: 1.2rem;
          transform: translateX(var(--pseudo-calc-translateX));
          transition: all ease .2s;
        }
      }

      .payment-date {
        margin-bottom: 2rem;

        label {
          margin-right: .5rem;
        }

        input {
          background-color: #ebebeb;
          padding: 10px;
          border-radius: 5px;
        }
      }

      table {
        // margin-bottom: 3rem;

        th {
          text-align: right;

          p {
            margin: 0 .5rem;
            text-align: left;
          }
        }

        td {
          width: fit-content;

          input {
            width: fit-content;
            background-color: #ebebeb;
            text-align: right;
            padding: 10px;
            border-radius: 5px;
            margin: 3px .5rem;
          }
          .td-name {
            width: 250px;
            text-align: left;
            margin: 3px .5rem 3px 0;
          }
          .td-price {
            width: 100px;
          }
          .td-quantity {
            width: 70px;
          }
          .td-unit {
            width: 50px;
            text-align: center;
          }
          .delete-img {
            width: 20px;
            height: 20px;
            margin-left: 1rem;
            cursor: pointer;
          }
        }
      }

      .add-wrapper {
        width: 100%;
        margin-bottom: 2rem;
        .add-button {
          // position: absolute;
          // left: 10px;
          background: #1bffc6;
          border-radius: 99em;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;

          p {
            font-size: 20px;
            line-height: 1;
          }
        }
      }

      .detailed-price {
        display: flex;
        flex-direction: column;
        margin-bottom: 3rem;
        font-size: 14px;

        .label-wrapper {
          display: flex;
          justify-content: space-between;

          label {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          input {
            width: 120px;
            text-align: right;
          }
        }

        .total-price {
          font-size: 20px;
          margin-top: .5rem;
        }

        .middle-line {
          margin: .5rem 0;
        }
      }

      .note {
        width: 100%;
        margin-bottom: 2rem;
        p {
          margin-bottom: .5rem;
          font-size: 14px;
        }
        textarea {
          width: 100%;
          height: 150px;
          background-color: #ebebeb;
          border-radius: 5px;
          padding: 10px;
          line-height: 1.5;
        }

        .bank-account {
          height: 100px;
        }
      }

    }

    .bottom-section {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: end;
      position: absolute;
      bottom: 0;
      height: 80px;
      border-top: 1px #000 solid;
      background-color: #fff;
      .button-group {
        display: flex;
        margin-right: 3rem;
        .button {
          display: flex;
          align-items: center;
          box-sizing: border-box;

          // color: white;
          // background: #00939D;
          color: #000;
          background: #1bffc6;
          border-radius: 99em;
          width: fit-content;
          height: 45px;
          margin-left: 1rem;
          margin-right: 0;

          padding: 0px 15px;

          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 1;

          overflow: hidden;

          img, span {
            display: inline-block;
            z-index: 2;
          }

          img {
            margin-right: 10px;
          }

        }

        .green-button {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            background-color: #1be0a8;
            top: 0;
            left: auto;
            right: 0;
            width: 0;
            height: 100%;
            transition-duration: .5s;
            transition-timing-function: cubic-bezier(.075,.82,.165,1);
            z-index: 1;
          }

          &:hover{
            &::before {
              width: 100%;
              left: 0;
              right: auto;
            }
          }
        }

        .border-button {
          background: none;
          border: #000 1px solid;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/CalculatePopup.vue